export const formatHours = (totalHours: number): string => {
  const sign = totalHours < 0 ? '-' : '';
  const absTotal = Math.abs(totalHours);

  const hours = Math.floor(absTotal);
  const minutes = Math.floor((absTotal % 1) * 60);

  return `${sign}${hours}h${minutes ? ` ${minutes}m` : ''}`;
};
